import React from 'react';
import { Card } from '../components/ui';
import { BLUE_PRIMARY, BLUE_PRIMARY_DARK } from '../theme';

export default function AttendanceSummary({ stats }) {
  const backend = stats;
  if (!backend) return null;

  const total = typeof backend.total === 'number' ? backend.total : 0;
  if (!total) return null;

  const present = backend.present_count || 0;
  const late = backend.late_count || 0;
  const absent = backend.absent_count || 0;

  const pct = (n, d) => (d ? Math.round((n / d) * 1000) / 10 : 0);

  const presentPct = (typeof backend.present_pct === 'number') ? backend.present_pct : pct(present, total);
  const latePct = (typeof backend.late_pct === 'number') ? backend.late_pct : pct(late, total);
  const absentPct = (typeof backend.absent_pct === 'number') ? backend.absent_pct : pct(absent, total);

  return (
    <Card title="Yoklama Durumları">
      <div style={{ display: 'grid', gap: 10 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 8 }}>
          <div style={{ background: '#fff', border: '1px solid #eef2f7', borderRadius: 12, padding: 10 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 8 }}>
              <div style={{ fontSize: 12, color: '#16a34a', fontWeight: 700 }}>Geldi</div>
              <div style={{ fontSize: 12, color: '#64748b' }}>{presentPct}%</div>
            </div>
            <div style={{ fontSize: 20, fontWeight: 800, color: '#0f172a' }}>{present}</div>
          </div>

          <div style={{ background: '#fff', border: '1px solid #eef2f7', borderRadius: 12, padding: 10 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 8 }}>
              <div style={{ fontSize: 12, color: '#B45309', fontWeight: 700 }}>Geç kaldı</div>
              <div style={{ fontSize: 12, color: '#64748b' }}>{latePct}%</div>
            </div>
            <div style={{ fontSize: 20, fontWeight: 800, color: '#0f172a' }}>{late}</div>
          </div>

          <div style={{ background: '#fff', border: '1px solid #eef2f7', borderRadius: 12, padding: 10 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 8 }}>
              <div style={{ fontSize: 12, color: BLUE_PRIMARY_DARK, fontWeight: 700 }}>Gelmedi</div>
              <div style={{ fontSize: 12, color: '#64748b' }}>{absentPct}%</div>
            </div>
            <div style={{ fontSize: 20, fontWeight: 800, color: '#0f172a' }}>{absent}</div>
          </div>
        </div>

        <div style={{ height: 10, borderRadius: 999, overflow: 'hidden', background: '#eef2f7', display: 'flex' }}>
          <div style={{ width: `${presentPct}%`, background: '#22c55e' }} />
          <div style={{ width: `${latePct}%`, background: '#F59E0B' }} />
          <div style={{ width: `${absentPct}%`, background: BLUE_PRIMARY }} />
        </div>

        <div style={{ fontSize: 12, color: '#64748b' }}>
          Toplam kayıt: <span style={{ fontWeight: 700, color: '#0f172a' }}>{total}</span>
        </div>
      </div>
    </Card>
  );
}
